module.exports = __webpack_public_path__ + "img/icon-douyin.2c9d13f9.png";